import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverviewComponent } from './components/overview/overview.component';
import { HeaderTitleComponent } from './components/header/title/title.component';
import { HeaderSidebarComponent } from './components/header/sidebar/sidebar.component';
import { ALL_ORDERS, REPORTS, MONITOR } from './gameday.constants';
import { AllOrdersComponent } from '../all-orders/components/all-orders/all-orders.component';
import { ReportsComponent } from '../reports/components/reports/reports.component';
import { MonitorComponent } from '../monitor/components/monitor/monitor.component';
import { DealComponent } from './components/deal/deal.component';
import { DealResolver } from './resolvers/deal.resolver';

export const routesModule = RouterModule.forChild([
  {
    path: '',
    component: DealComponent,
    data: {
      titleComponent: HeaderTitleComponent,
      headerSidebarComponent: HeaderSidebarComponent
    },
    canActivate: [DealResolver],
    children: [
      {
        path: ALL_ORDERS,
        component: AllOrdersComponent,
        data: {
          section: 'All Orders',
          back: {
            remove: 1,
            keepParams: true
          }
        }
      },
      {
        path: REPORTS,
        component: ReportsComponent,
        data: {
          section: 'Reports',
          back: {
            remove: 1,
            keepParams: true
          }
        }
      },
      {
        path: MONITOR,
        component: MonitorComponent,
        data: {
          section: 'Order Monitor',
          back: {
            remove: 1,
            keepParams: true
          }
        }
      },
      {
        path: '',
        component: OverviewComponent,
        data: {
          back: {
            remove: 2,
            keepParams: false
          }
        }
      }
    ]
  }
]);
@NgModule({
  imports: [routesModule],
  exports: [RouterModule]
})
export class GamedayRoutingModule {}
